import { ONBOARD, RATE, TERMS } from '@/constants/routes';

/**
 * Authenticated routes that render their own full-page shell (e.g. AuthPageShell)
 * and must not nest under the main app Layout / sidebar Navigation.
 */
export function isChromeFreePrivatePath(pathname: string): boolean {
  return (
    pathname.includes(RATE) ||
    pathname.includes(ONBOARD) ||
    pathname.includes(TERMS)
  );
}
